//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Components */
import { SAC_BASIC } from './index';
import {
  normalizeAttendeeWorkerRow,
  IsExternalAttendeeWorker,
  IsMeetingMinutesLocked,
} from './SAC_BASIC_ColumnDefs';

import dayjs from 'dayjs';
import useDelete from '../../../../hooks/useDeleteN';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useActionLog from '../../../../hooks/useActionLog';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
  useSearch5,
  useSave1,
  useSave2,
  useSave3,
  useSave4,
  useDelete1,
  useDelete2,
  useDelete3,
} from './SAC_BASIC_QUERY';
import {
  mapParamsBySchema,
  mapRowsBySchema,
  toPreviewSrc,
} from '../../../../util';
import { SAC_BASIC_Schema } from './SAC_BASIC_Schema';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'SafetyCommittee';

//#region 상수
const Inputs = {
  // 회의록 관련 필드
  chaebun: '', // 채번
  proceedingsDate: dayjs(), // 회의일시
  proceedingsStartTime: dayjs(), // 시작일시
  proceedingsEndTime: dayjs(), // 종료일시
  proceedingsLocation: '', // 회의장소
  proceedingsTitle: '', // 회의제목
  address: '', // 주소
  fileName: '', // 파일명
  saveName: '', // 저장명
  fcmToken: '', // FCM 토큰
};

function SAC_BASICF() {
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  //로그 관련
  const { SaveActionLog } = useActionLog();

  //#region 변수
  const gridRef1 = useRef(); //회사정보 그리드
  const gridRef2User = useRef(); // 사용자위원 참석자 그리드
  const gridRef2Labor = useRef(); // 근로자위원 참석자 그리드
  const gridRef3 = useRef(); //참석인원 추가 팝업 그리드
  const gridRef5 = useRef(); //회사정보 그리드
  const gridRef8 = useRef(); // 이전 회의 리스트 팝업 그리드
  const inputsRef = useRef(Inputs);
  const [inputs, setInputs] = useState(Inputs); // 진행사진데이터
  const [imageFile, setImageFile] = React.useState({
    //이미지 설정
    mapFiles: '', //파일 String
    mapFileName: '', //파일이름
  });
  //로그 관련
  const [loading, setLoading] = useState(false);
  const [modalToggle1, setModalToggle1] = useState(false);

  // 회의정보 등록팝업
  const [modalToggle2, setModalToggle2] = React.useState(false); // 회의록 팝업 창
  const [modalRowData2, setModalRowData2] = React.useState({}); // 회의록 팝업 데이터
  const [attendeeData0, setAttendeeData0] = React.useState([]); // 사용자위원(gubun 0) 참석자
  const [attendeeData1, setAttendeeData1] = React.useState([]); // 근로자위원(gubun 1) 참석자
  /** 참석인원 추가 팝업을 연 그리드: '0' 사용자위원 | '1' 근로자위원 */
  const attendeeAddTargetGubunRef = useRef('0');

  // 회의정보 등록팝업안의 참석인원 추가하기 팝업
  const [modalToggle3, setModalToggle3] = React.useState(false); // 참석인원 추가 팝업 창
  const [modalRowData3, setModalRowData3] = React.useState([]); // 참석인원 추가 팝업 데이터
  const [selectedModalRowData3, setSelectedModalRowData3] = React.useState([]); // 참석인원 추가 팝업 ROW선택 데이터
  const [changedModalRowData3, setChangedModalRowData3] = React.useState([]); // 참석인원 추가 팝업 변경 데이터
  const [deletedModalRowData3, setDeletedModalRowData3] = React.useState([]); // 참석인원 추가 팝업 삭제 데이터

  const [searchKeyword, setSearchKeyword] = React.useState(''); // 검색 키워드
  const [searchResults, setSearchResults] = React.useState([]); // 검색 결과
  const [selectedWorkers, setSelectedWorkers] = React.useState([]); // 선택된 근로자들
  const [attendeeList, setAttendeeList] = React.useState([]); // 참석자 목록

  const [meetingAgendaData, setMeetingAgendaData] = React.useState([]); // 회의안건 데이터

  const imgRef2 = useRef(null); //진행사진
  const printRef = useRef([]); //참석자 명단 데이터

  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: false, requireCust: true });
  // 회의록 기본정보 그리드
  const [rowData1, setRowData1] = useState([]); // 회의록기본정보 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 회의록기본정보 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 회의록기본정보 그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]); // 회의록기본정보 그리드 삭제 시 데이터
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);
  const [currentChaebun, setCurrentChaebun] = useState('');
  const currentChaebunRef = useRef(''); // currentChaebun의 최신 값을 추적하기 위한 ref

  const [isEditing, setIsEditing] = React.useState(false);

  // 삭제 PayLoad
  const delete1 = useDelete1();
  const delete2 = useDelete2({ userInfo: userInfo });

  // 삭제 Handler
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  //구분 리스트
  const [gubunList, setGubunList] = useState([
    {
      value: '0',
      name: '사용자위원',
    },
    {
      value: '1',
      name: '근로자위원',
    },
  ]);
  //#endregion

  //#region 조회
  // 그리드 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (processedRows) => {
      setRowData1(processedRows);
      dispatch(closeLoading());
    },
  });

  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  // 그리드 조회 래퍼 (ResetLogic1 + Search1 통합)
  const SearchLogic1 = async (_value1) => {
    ResetLogic1();
    await Search1();
  };

  // 그리드 행 삭제 버튼: 선택 행을 "삭제예정"으로 표시
  const DeleteLogic1 = () => {
    if (!selectedRowData1 || selectedRowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '삭제할 행을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    const newRowExists = selectedRowData1.some((row) => row.newYn === 'Y');
    if (newRowExists) {
      dispatch(
        showSnackbar({
          message: '데이터 입력중입니다. 저장 후 시도하세요.',
          type: 'warning',
        })
      );
      return;
    }

    deleteHandler1.MarkedForDeletion(selectedRowData1);
  };

  // 참석자 정보 조회
  const { run: Search2 } = useSearch2({
    onSuccess: (rows) => {
      if (rows && rows.length > 0) {
        const attendeeList = rows.map((item) => ({
          id: item.id || item.ID || '',
          rank: item.rank || item.RANK || '',
          position: item.position || item.POSITION || '',
          name: item.NAME || item.name || '',
          tel: item.TEL || item.tel || '',
          depNm: item.DEP_NM || item.depNm || '',
          gubun: item.GUBUN || item.gubun || '0',
          checkYn: item.CHECK_YN || item.checkYn || 'N',
          checkPath: item.CHECK_PATH || item.checkPath || '',
          attendYn: item.ATTEND_YN || item.attendYn || 'N',
          nonAttendReason: item.NON_ATTEND_REASON || item.nonAttendReason || '',
        }));

        const validAttendeeList = attendeeList.filter(
          (attendee) => attendee && attendee.id && attendee.id.trim() !== ''
        );

        const list0 = validAttendeeList.filter((a) => a.gubun === '0');
        const list1 = validAttendeeList.filter((a) => a.gubun === '1');

        setAttendeeData0(list0);
        setAttendeeData1(list1);

        // totalWorkers 업데이트 (참석자 수)
        setModalRowData2((prev) => ({
          ...prev,
          totalWorkers: validAttendeeList.length || 0,
        }));
      } else {
        setAttendeeData0([]);
        setAttendeeData1([]);
      }
    },
  });

  // 참석인원추가하기 팝업- 참석인원 조회 함수
  // 외부인(internalYn='1')은 제외 — 우리 사업장 근로자만 선택
  const { run: Search5 } = useSearch5({
    onSuccess: (rows) => {
      const internalOnly = (rows || [])
        .filter((row) => !IsExternalAttendeeWorker(row))
        .map(normalizeAttendeeWorkerRow);
      setModalRowData3(internalOnly);
    },
  });
  // 참석자 기본정보 그리드 조회회
  const handleAttendeeSearch = async () => {
    await Search5();
  };

  // 이름 또는 사번으로 검색
  const handleSearchWorkers = async () => {
    await Search5();
  };

  /** 참석인원 추가 팝업: 어느 위원 그리드에서 열었는지(gubun)에 따라 추가 대상이 결정됨 */
  const OpenAttendeeAddModal = async (gubun) => {
    attendeeAddTargetGubunRef.current = gubun === '1' ? '1' : '0';
    await handleAttendeeSearch();
    setModalToggle3(true);
  };

  // 저장 hooks
  const { runAsync: Save1Async } = useSave1({
    userInfo,
    search: {
      custCd: searchInfo.custCd,
      year: searchInfo.year,
    },
  });

  const { runAsync: Save2Async } = useSave2({
    userInfo,
  });

  //#region 회의정보 팝업 추가 또는 수정
  const PopupClickEvent2Update = async (_data) => {
    // 그리드 데이터를 먼저 세팅
    const chaebun = _data.chaebun || _data.CHAEBUN || '';

    if (chaebun && chaebun.trim() !== '') {
      setCurrentChaebun(chaebun);
      currentChaebunRef.current = chaebun;
    } else {
      setCurrentChaebun('');
      currentChaebunRef.current = '';
      setMeetingAgendaData([]);
    }

    setModalRowData2({
      chaebun: chaebun,
      proceedingsTitle: _data.proceedingsTitle || _data.PROCEEDINGS_TITLE || '',
      proceedingsDate: _data.proceedingsDate
        ? dayjs(_data.proceedingsDate).format('YYYY-MM-DD')
        : _data.PROCEEDINGS_DATE
          ? dayjs(_data.PROCEEDINGS_DATE).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
      proceedingsStartTime: (() => {
        const timeValue =
          _data.proceedingsStartTime || _data.PROCEEDINGS_START_TIME;
        if (!timeValue) return null;

        // "0 15:15:00.000000" 형식을 "15:15"로 변환
        if (typeof timeValue === 'string') {
          const timeMatch = timeValue.match(/(\d{1,2}):(\d{2})/);
          if (timeMatch) {
            const hours = timeMatch[1].padStart(2, '0');
            const minutes = timeMatch[2];
            return dayjs(`${hours}:${minutes}`, 'HH:mm');
          }
        }

        // dayjs 객체인 경우
        if (dayjs.isDayjs(timeValue)) {
          return timeValue;
        }

        // dayjs로 파싱 시도
        const parsed = dayjs(timeValue, ['HH:mm', 'HH:mm:ss', 'HH:mm:ss.SSS']);
        return parsed.isValid() ? parsed : null;
      })(),
      proceedingsEndTime: (() => {
        const timeValue =
          _data.proceedingsEndTime || _data.PROCEEDINGS_END_TIME;
        if (!timeValue) return null;

        // "0 15:15:00.000000" 형식을 "15:15"로 변환
        if (typeof timeValue === 'string') {
          const timeMatch = timeValue.match(/(\d{1,2}):(\d{2})/);
          if (timeMatch) {
            const hours = timeMatch[1].padStart(2, '0');
            const minutes = timeMatch[2];
            return dayjs(`${hours}:${minutes}`, 'HH:mm');
          }
        }

        // dayjs 객체인 경우
        if (dayjs.isDayjs(timeValue)) {
          return timeValue;
        }

        // dayjs로 파싱 시도
        const parsed = dayjs(timeValue, ['HH:mm', 'HH:mm:ss', 'HH:mm:ss.SSS']);
        return parsed.isValid() ? parsed : null;
      })(),
      proceedingsLocation:
        _data.proceedingsLocation || _data.PROCEEDINGS_LOCATION || '',
      signRequestYn:
        _data.signRequestYn ||
        _data.SignRequestYn ||
        _data.SIGN_REQUEST_YN ||
        'N',
      totalWorkers: 0,
    });

    setModalToggle2(true);
    setAttendeeData0([]);
    setAttendeeData1([]);

    dispatch(showLoading());
    try {
      if (chaebun && chaebun.trim() !== '') {
        await Search2({
          search: {
            chaebun: chaebun,
          },
        });
        await Search4({
          search: {
            chaebun: chaebun,
          },
        });
        await Search3({
          search: {
            chaebun: chaebun,
            searchText: '',
          },
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(closeLoading());
    }
    // 참석인원 추가 팝업용 조회
    await handleAttendeeSearch();
  };
  //#endregion

  //#region 회의안건
  // 회의 마스터 정보 조회 (이미지 포함)
  const { run: Search4 } = useSearch4({
    onSuccess: (masterData) => {
      if (masterData) {
        // 이미지 경로 추출 (대소문자 구분 없이)
        const imagePath =
          masterData.PROCEEDINGS_IMAGE ||
          masterData.proceedingsImage ||
          masterData.PROCEEDINGS_IMAGE_PATH ||
          masterData.proceedingsImagePath ||
          '';

        const imageName =
          masterData.PROCEEDINGS_IMAGE_NM ||
          masterData.proceedingsImageNm ||
          masterData.PROCEEDINGS_IMAGE_NAME ||
          masterData.proceedingsImageName ||
          '';

        // 팝업이 열려있을 때는 PopupClickEvent5에서 이미 이미지를 로드했을 수 있으므로 덮어쓰지 않음
        // currentChaebunRef.current가 설정되어 있으면 팝업이 열려있는 것으로 간주 (useRef를 사용하여 최신 값 보장)
        if (currentChaebunRef.current) {
          // 이미지가 있고 아직 로드되지 않았을 때만 로드 (새로고침 후 첫 클릭 시 대응)
          if (imagePath && imagePath.trim() !== '' && !imgRef2.current) {
            const imageUrl = `${Global.file.useUrl}files/${imagePath}`;
            imgRef2.current = imageUrl;
            // inputsRef도 업데이트
            inputsRef.current = {
              ...inputsRef.current,
              fileName: imageName || inputsRef.current.fileName,
              saveName: imagePath
                ? imagePath.split('/').pop()
                : inputsRef.current.saveName,
              filePath: imagePath || inputsRef.current.filePath,
              PROCEEDINGS_IMAGE:
                imagePath || inputsRef.current.PROCEEDINGS_IMAGE,
              PROCEEDINGS_IMAGE_NM:
                imageName || inputsRef.current.PROCEEDINGS_IMAGE_NM,
              proceedingsImage: imagePath || inputsRef.current.proceedingsImage,
              proceedingsImageNm:
                imageName || inputsRef.current.proceedingsImageNm,
            };
          } else if (imagePath && imagePath.trim() !== '' && imgRef2.current) {
            // 이미 이미지가 로드되어 있으면 inputsRef만 업데이트 (imgRef2는 덮어쓰지 않음)
            inputsRef.current = {
              ...inputsRef.current,
              fileName: imageName || inputsRef.current.fileName,
              saveName: imagePath
                ? imagePath.split('/').pop()
                : inputsRef.current.saveName,
              filePath: imagePath || inputsRef.current.filePath,
              PROCEEDINGS_IMAGE:
                imagePath || inputsRef.current.PROCEEDINGS_IMAGE,
              PROCEEDINGS_IMAGE_NM:
                imageName || inputsRef.current.PROCEEDINGS_IMAGE_NM,
              proceedingsImage: imagePath || inputsRef.current.proceedingsImage,
              proceedingsImageNm:
                imageName || inputsRef.current.proceedingsImageNm,
            };
          } else if (!imagePath || imagePath.trim() === '') {
            // imagePath가 없을 때는 이미 로드된 이미지가 있으면 유지
            // PopupClickEvent5에서 이미 로드했을 수 있으므로 초기화하지 않음
            // 단, inputsRef의 파일명 정보는 업데이트
            if (!imgRef2.current) {
              // 이미지가 없고, 로드된 이미지도 없으면 초기화 (삭제된 경우)
              inputsRef.current = {
                ...inputsRef.current,
                fileName: '',
                saveName: '',
                filePath: '',
                PROCEEDINGS_IMAGE: '',
                PROCEEDINGS_IMAGE_NM: '',
                proceedingsImage: '',
                proceedingsImageNm: '',
              };
            } else {
              // 이미 로드된 이미지가 있으면 유지 (PopupClickEvent5에서 로드했을 수 있음)
              // inputsRef의 파일명 정보만 업데이트
              inputsRef.current = {
                ...inputsRef.current,
                PROCEEDINGS_IMAGE: '',
                PROCEEDINGS_IMAGE_NM: '',
                proceedingsImage: '',
                proceedingsImageNm: '',
              };
            }
          }
        } else {
          // 팝업이 닫혀있을 때는 기존 로직 사용
          inputsRef.current = {
            ...inputsRef.current,
            fileName: imageName,
            saveName: imagePath ? imagePath.split('/').pop() : '',
            filePath: imagePath,
            PROCEEDINGS_IMAGE: imagePath,
            PROCEEDINGS_IMAGE_NM: imageName,
            proceedingsImage: imagePath,
            proceedingsImageNm: imageName,
          };

          if (imagePath && imagePath.trim() !== '') {
            SearchPhoto(imagePath);
          } else {
            imgRef2.current = null;
          }
        }
      } else {
        // masterData가 없을 때는 팝업이 열려있을 때는 덮어쓰지 않음
        if (!currentChaebunRef.current) {
          // 팝업이 닫혀있을 때만 초기화
          imgRef2.current = null;
        }
        // currentChaebunRef.current가 있으면 이미 로드된 이미지를 유지 (덮어쓰지 않음)
      }
    },
  });

  // 회의안건 조회
  const { run: Search3 } = useSearch3({
    onSuccess: async (data) => {
      if (data && data.length > 0) {
        const agendaList = data.map((item, index) => ({
          id: item.SEQ || item.seq || `temp-${Date.now()}-${index}`,
          CHAEBUN: item.CHAEBUN || item.chaebun || '',
          chaebun: item.CHAEBUN || item.chaebun || '',
          SEQ: item.SEQ || item.seq || '',
          seq: item.SEQ || item.seq || '',
          agendaName: item.AGENDA_NAME || item.agendaName || '',
          person: item.person || '',
          processingDeadline: item.processingDeadline || '',
          resultDiscussion: item.resultDiscussion || '',
          editYn: 'N',
          newYn: 'N',
        }));

        setMeetingAgendaData(agendaList);

        // 회의정보 조회 시 채번 설정 (회의안건 저장 시 사용)
        const chaebunFromData = data[0]?.CHAEBUN || data[0]?.chaebun;
        if (chaebunFromData) {
          setCurrentChaebun(chaebunFromData);
          currentChaebunRef.current = chaebunFromData;
        }
      } else {
        setMeetingAgendaData([]);
      }
    },
  });

  // 회의결과(회의안건) 컬럼 클릭 — 통합 회의 팝업(modal2)으로 연결
  const PopupClickEvent5 = async (_data, options = {}) => {
    const { refreshOnly = false } = options;

    if (refreshOnly) {
      const chaebun =
        _data.CHAEBUN ||
        _data.chaebun ||
        currentChaebunRef.current ||
        currentChaebun ||
        '';
      if (!chaebun || chaebun.trim() === '') {
        return;
      }
      const filePathFromData =
        _data.filePath ||
        _data.FILE_PATH ||
        _data.FilePath ||
        _data.proceedingsImage ||
        _data.PROCEEDINGS_IMAGE ||
        '';
      if (filePathFromData) {
        const imageUrl = `${Global.file.useUrl}files/${filePathFromData}`;
        imgRef2.current = imageUrl;
        const fileName = filePathFromData.split('/').pop() || '';
        inputsRef.current = {
          ...Inputs,
          fileName: fileName,
          saveName: fileName,
          filePath: filePathFromData,
          proceedingsImage: filePathFromData,
          PROCEEDINGS_IMAGE: filePathFromData,
        };
      }
      dispatch(showLoading());
      try {
        await Search4({
          search: {
            chaebun: chaebun,
          },
        });
        await Search3({
          search: {
            chaebun: chaebun,
            searchText: '',
          },
        });
      } catch (e) {
        console.log(e);
        dispatch(showSnackbar({ message: e.message, type: 'error' }));
      } finally {
        dispatch(closeLoading());
      }
      return;
    }

    const chaebun = _data.CHAEBUN || _data.chaebun || '';

    if (!chaebun || chaebun.trim() === '') {
      dispatch(
        showSnackbar({
          message: '회의 채번이 없습니다.',
          type: 'error',
        })
      );
      return;
    }

    setMeetingAgendaData([]);

    const prevChaebun = currentChaebunRef.current;
    if (prevChaebun && prevChaebun !== chaebun) {
      imgRef2.current = null;
      inputsRef.current = Inputs;
    }

    const filePathFromData =
      _data.filePath ||
      _data.FILE_PATH ||
      _data.FilePath ||
      _data.proceedingsImage ||
      _data.PROCEEDINGS_IMAGE ||
      '';

    if (filePathFromData) {
      const imageUrl = `${Global.file.useUrl}files/${filePathFromData}`;
      imgRef2.current = imageUrl;
      const fileName = filePathFromData.split('/').pop() || '';
      inputsRef.current = {
        ...Inputs,
        fileName: fileName,
        saveName: fileName,
        filePath: filePathFromData,
        proceedingsImage: filePathFromData,
        PROCEEDINGS_IMAGE: filePathFromData,
      };
    }

    try {
      await PopupClickEvent2Update(_data);
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#region 회의 개최
  // 회의 개최 함수
  const { runAsync: Save4Async } = useSave4({
    userInfo,
  });

  const handleMeetingStart = async (type, meetingData) => {
    try {
      const result = await Save4Async([
        {
          chaebun: meetingData.CHAEBUN || meetingData.chaebun,
          state: type,
        },
      ]);

      if (!result?.isSuccess) {
        dispatch(
          showSnackbar({
            message:
              result?.message || '회의 개최 처리 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
        return;
      }

      ResetLogic1();
      if (!validateSelection()) return;
      await Search1();
      dispatch(
        showSnackbar({
          message: '회의가 개최되었습니다.',
          type: 'success',
        })
      );
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    }
  };
  //#endregion

  //#region 회의안건 추가
  const addMeetingAgenda = () => {
    const newItem = {
      id: Date.now(),
      AGENDA_NAME: '',
      RESULT_DISCUSSION: '',
      newYn: 'Y',
    };

    const updated = [...meetingAgendaData, newItem];
    setMeetingAgendaData(updated);

    // 그리드가 업데이트된 후 포커스 설정
    requestAnimationFrame(() => {
      const newRowIndex = updated.length - 1;
      if (gridRef5.current?.api) {
        // 먼저 행을 선택
        gridRef5.current.api.setFocusedCell(newRowIndex, 'AGENDA_NAME');
        // 그 다음 편집 모드 시작
        gridRef5.current.api.startEditingCell({
          rowIndex: newRowIndex,
          colKey: 'AGENDA_NAME',
        });
        // 행을 화면에 보이도록 스크롤
        gridRef5.current.api.ensureIndexVisible(newRowIndex);
      }
    });
  };

  // #region 회의안건 삭제
  const deleteMeetingAgenda = (id) => {
    setMeetingAgendaData((prev) => {
      const item = prev.find((i) => i.id === id);

      if (!item) return prev;

      if (item.newYn === 'Y') {
        // 새로 추가된 행이면 완전 삭제
        return prev.filter((i) => i.id !== id);
      }

      // 기존 데이터면 deleteYn 토글
      return prev.map((i) => {
        if (i.id === id) {
          if (i.deleteYn === 'Y') {
            return { ...i, deleteYn: 'N' };
          }
          return { ...i, deleteYn: 'Y' };
        }
        return i;
      });
    });
  };

  // #region 회의안건 저장
  // 삭제 mutation
  const { mutateAsync: Delete3Async } = useDelete3({
    userInfo: userInfo,
  });

  // 저장 mutation
  const { mutateAsync: Save3Async } = useSave3({
    userInfo: userInfo,
  });

  const saveMeetingAgenda = async () => {
    dispatch(showLoading());

    try {
      const effectiveChaebun = currentChaebunRef.current || currentChaebun;

      const changedRows = meetingAgendaData.filter(
        (item) => item.newYn === 'Y' || item.editYn === 'Y'
      );
      const deletedRows = meetingAgendaData.filter(
        (item) => item.deleteYn === 'Y'
      );

      const inputsRefCurrent = inputsRef?.current;

      // 사진이 삭제되었는지 확인 (isImageDeleted 플래그 또는 imgRef2가 null이고 기존 파일이 있었던 경우)
      const isImageDeleted =
        inputsRefCurrent?.isImageDeleted ||
        (!imgRef2.current &&
          (inputsRefCurrent?.filePath || inputsRefCurrent?.fileName));
      // mapFile이 있거나 newYn이 'Y'이면 사진이 변경된 것으로 간주
      const isImageUpdated = !!(
        inputsRefCurrent?.mapFile ||
        inputsRefCurrent?.newYn === 'Y' ||
        isImageDeleted
      );

      // === 1. 이미지 파일 업로드 (먼저 처리하여 경로 확보) ===
      let imagePath = '';
      let imageFileName = '';

      // 사진이 삭제된 경우 빈값으로 설정
      if (isImageDeleted) {
        imagePath = '';
        imageFileName = '';
        // inputsRef도 초기화
        inputsRef.current = {
          ...inputsRef.current,
          filePath: '',
          fileName: '',
          saveName: '',
          mapFile: null,
          isImageDeleted: false, // 플래그 초기화
        };
      } else if (inputsRefCurrent?.mapFile) {
        const uploadedFilePath = await SaveLogic3(
          inputsRefCurrent.mapFile,
          inputsRefCurrent.fileName
        );
        if (!uploadedFilePath) {
          // 파일 업로드 실패 시 저장 중단
          dispatch(
            showSnackbar({
              message: '파일 업로드 실패',
              type: 'error',
            })
          );
          return;
        }

        // SaveLogic3에서 이미 Business/{custCd}/SAC_BASIC/{filename} 형식으로 반환됨
        imagePath = uploadedFilePath;
        imageFileName = inputsRefCurrent?.fileName || '';
        inputsRef.current.filePath = uploadedFilePath;
        inputsRef.current.fileName = uploadedFilePath.split('/').pop() || '';
        inputsRef.current.isImageDeleted = false; // 플래그 초기화
      } else if (inputsRefCurrent?.fileName) {
        // 이미 업로드된 파일이 있는 경우
        // 파일명 추출 (전체 경로인 경우 마지막 부분만 사용)
        const fileName = inputsRefCurrent.saveName?.includes('/')
          ? inputsRefCurrent.saveName.split('/').pop()
          : inputsRefCurrent.saveName || inputsRefCurrent.fileName;

        // 항상 Business/${searchInfo.custCd}/SAC_BASIC/fileName 형식으로 정규화
        imagePath = `Business/${searchInfo.custCd}/SAC_BASIC/${fileName}`;
        imageFileName = inputsRefCurrent?.fileName || '';
      }

      // === 2. 회의안건 삭제 처리 ===
      // 서버는 단일 객체만 받으므로 각 항목을 개별적으로 삭제
      if (deletedRows.length > 0) {
        const deletedIds = []; // 삭제 성공한 항목의 id 목록

        for (const item of deletedRows) {
          const chaebunValue = item.CHAEBUN || item.chaebun || effectiveChaebun;
          const seqValue = (item.SEQ || item.seq)?.toString() || '';

          // seq가 없는 경우 건너뛰기 (신규 행은 DB에 없으므로 삭제 불필요)
          if (!seqValue || seqValue.trim() === '') {
            // 신규 행은 UI에서만 제거하면 되므로 id를 추가
            if (item.id) {
              deletedIds.push(item.id);
            }
            continue;
          }

          try {
            // useDelete3 hook 사용 (단일 객체 배열로 전달)
            const deleteResult = await Delete3Async([
              {
                chaebun: chaebunValue,
                seq: seqValue,
              },
            ]);

            if (!deleteResult?.isSuccess) {
              dispatch(
                showSnackbar({
                  message:
                    deleteResult?.message ||
                    '회의안건 삭제 중 오류가 발생했습니다.',
                  type: 'error',
                })
              );
            } else {
              // 삭제 성공한 항목의 id 추가
              if (item.id) {
                deletedIds.push(item.id);
              }
            }
          } catch (error) {
            dispatch(
              showSnackbar({
                message:
                  error?.message || '회의안건 삭제 중 오류가 발생했습니다.',
                type: 'error',
              })
            );
          }
        }

        // 삭제 성공한 항목을 UI에서 제거
        if (deletedIds.length > 0) {
          setMeetingAgendaData((prev) =>
            prev.filter((item) => !deletedIds.includes(item.id))
          );
        }
      }

      // === 3. 저장할 데이터 준비 (회의안건 + 이미지) ===
      const saveRows = [];

      // 회의안건 저장 (Gubun: '0')
      if (changedRows.length > 0) {
        changedRows.forEach((item) => {
          const chaebunValue = item.CHAEBUN || item.chaebun || effectiveChaebun;
          saveRows.push({
            gubun: '0', // 안건 등록
            chaebun: chaebunValue,
            seq: (item.SEQ || item.seq)?.toString() || '',
            agendaName: item.AGENDA_NAME || item.agendaName || '',
            resultDiscussion:
              item.RESULT_DISCUSSION || item.resultDiscussion || '',
            person: item.PERSON || item.person || '',
            processingDeadline:
              item.PROCESSING_DEADLINE || item.processingDeadline || '',
            proceedingsImage: imagePath,
            proceedingsImageNm: imageFileName,
          });
        });
      }

      // 진행사진만 등록한 경우 (Gubun: '1')
      // 이미지가 업데이트되었거나 삭제된 경우 (changedRows가 없고, imagePath가 있거나 isImageDeleted가 true인 경우)
      if (isImageUpdated && changedRows.length === 0) {
        saveRows.push({
          gubun: '1', // 사진만 저장
          chaebun: effectiveChaebun,
          seq: '',
          agendaName: '',
          resultDiscussion: '',
          person: '',
          processingDeadline: '',
          proceedingsImage: imagePath, // 삭제된 경우 빈값
          proceedingsImageNm: imageFileName, // 삭제된 경우 빈값
        });
      }

      // === 4. 회의안건 저장 (배열로 전송) ===
      if (saveRows.length > 0) {
        // chaebun 값이 모두 있는지 확인
        const hasEmptyChaebun = saveRows.some(
          (row) => !row.chaebun || row.chaebun.trim() === ''
        );
        if (hasEmptyChaebun) {
          dispatch(
            showSnackbar({
              message: '회의 채번이 없는 항목이 있습니다.',
              type: 'error',
            })
          );
          return;
        }

        const result = await Save3Async(saveRows);

        // 배치 응답 처리
        if (result?.data) {
          const results = Array.isArray(result.data)
            ? result.data
            : [result.data];
          const hasError = results.some((r) => !r.isSuccess);

          if (hasError) {
            const errorResult = results.find((r) => !r.isSuccess);
            dispatch(
              showSnackbar({
                message: errorResult?.message || '저장 중 오류가 발생했습니다.',
                type: 'error',
              })
            );
            return;
          }
        }
      }

      dispatch(showSnackbar({ message: '저장되었습니다.', type: 'success' }));

      // 저장된 파일 경로 가져오기
      // 우선순위: inputsRef.current.filePath > imagePath
      const savedFilePath = inputsRef.current?.filePath || imagePath || '';

      // 팝업 재조회 (저장된 파일 경로 전달)
      await PopupClickEvent5(
        {
          CHAEBUN: effectiveChaebun,
          chaebun: effectiveChaebun,
          filePath: savedFilePath,
          FILE_PATH: savedFilePath,
          proceedingsImage: savedFilePath,
          PROCEEDINGS_IMAGE: savedFilePath,
        },
        { refreshOnly: true }
      );
      // 회의 개최상태를 위해 재조회
      ResetLogic1();
      if (!validateSelection()) return;
      await Search1();
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message || '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  //#region 회의록 저장
  const SaveLogic1 = async (options = {}) => {
    const suppressSuccessSnackbar = options?.suppressSuccessSnackbar === true;
    // 회의제목, 회의장소 입력 체크
    if (
      !modalRowData2?.proceedingsTitle ||
      !modalRowData2?.proceedingsLocation
    ) {
      dispatch(
        showSnackbar({
          message: '회의제목, 회의장소를 입력해주세요.',
          type: 'warning',
        })
      );
      return false;
    }
    // 참석자 체크
    if (attendeeData0.length + attendeeData1.length === 0) {
      dispatch(
        showSnackbar({
          message: `참석자를 한명 이상 추가해주세요.`,
          type: 'warning',
        })
      );
      return false;
    }
    // 회의안건 체크
    if (meetingAgendaData.length === 0) {
      dispatch(
        showSnackbar({
          message: '회의안건을 추가해주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    dispatch(showLoading());

    try {
      // 등록/수정 구분: 채번이 있으면 수정, 없으면 등록
      const isUpdate = modalRowData2.chaebun && modalRowData2.chaebun !== '';

      // 시간 값을 "HH:mm" 형식의 문자열로 변환하는 헬퍼 함수
      // 반환값: "19:00", "11:30" 형식의 문자열 또는 빈 문자열
      const formatTimeForSave = (timeValue) => {
        if (!timeValue) return '';

        // dayjs 객체인 경우
        if (dayjs.isDayjs(timeValue)) {
          return timeValue.format('HH:mm');
        }

        // 문자열인 경우 파싱 후 변환
        const timeStr = String(timeValue).trim();

        // 이미 "HH:mm" 형식인 경우
        if (/^\d{1,2}:\d{2}$/.test(timeStr)) {
          const parts = timeStr.split(':');
          const hours = parts[0].padStart(2, '0');
          const minutes = parts[1];
          return `${hours}:${minutes}`;
        }

        // "0 15:30:00.000000" 형태를 "15:30"로 변환
        const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})/);
        if (timeMatch) {
          const hours = timeMatch[1].padStart(2, '0');
          const minutes = timeMatch[2];
          return `${hours}:${minutes}`;
        }

        // dayjs로 파싱 시도
        const parsed = dayjs(timeValue, ['HH:mm', 'HH:mm:ss', 'HH:mm:ss.SSS']);
        if (parsed.isValid()) {
          return parsed.format('HH:mm');
        }

        return '';
      };

      // 저장할 데이터 준비
      const saveRow = {
        chaebun: modalRowData2.chaebun || '',
        proceedingsDate: modalRowData2.proceedingsDate || dayjs(),
        proceedingsStartTime: formatTimeForSave(
          modalRowData2.proceedingsStartTime
        ),
        proceedingsEndTime: formatTimeForSave(modalRowData2.proceedingsEndTime),
        proceedingsLocation: modalRowData2.proceedingsLocation || '',
        proceedingsTitle: modalRowData2.proceedingsTitle || '',
        state: '0', // 개최전
      };

      // useSave1의 runAsync 사용
      const result = await Save1Async([saveRow]);

      if (!result?.isSuccess) {
        dispatch(
          showSnackbar({
            message: result?.message || '저장 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
        return false;
      }

      let savedChaebun = null;

      // 서버 응답에서 chaebun 추출 (여러 가능한 구조 확인)
      if (result?.data) {
        if (Array.isArray(result.data) && result.data.length > 0) {
          // 배열 형식: [{ Chaebun: 'xxx' }]
          savedChaebun = result.data[0]?.Chaebun || result.data[0]?.chaebun;
        } else if (typeof result.data === 'object') {
          // 객체 형식: { Chaebun: 'xxx' } 또는 { data: [{ Chaebun: 'xxx' }] }
          savedChaebun = result.data.Chaebun || result.data.chaebun;
          if (
            !savedChaebun &&
            result.data.data &&
            Array.isArray(result.data.data)
          ) {
            savedChaebun =
              result.data.data[0]?.Chaebun || result.data.data[0]?.chaebun;
          }
        }
      }

      // 기존 chaebun이 있으면 사용 (수정 모드)
      if (!savedChaebun) {
        savedChaebun = modalRowData2.chaebun;
      }

      if (!savedChaebun || savedChaebun.trim() === '') {
        dispatch(
          showSnackbar({
            message:
              '저장은 성공했지만 채번을 확인할 수 없어 참석자 정보를 저장할 수 없습니다.',
            type: 'warning',
          })
        );
        return false;
      }

      setModalRowData2((prev) => ({
        ...prev,
        chaebun: savedChaebun,
      }));

      setCurrentChaebun(savedChaebun);
      currentChaebunRef.current = savedChaebun;

      await SaveLogic2(savedChaebun, [
        ...attendeeData0.map((r) => ({ ...r, gubun: '0' })),
        ...attendeeData1.map((r) => ({ ...r, gubun: '1' })),
      ]);

      if (!suppressSuccessSnackbar) {
        dispatch(
          showSnackbar({
            message: isUpdate ? '수정되었습니다.' : '등록되었습니다.',
            type: 'success',
          })
        );
      }

      // 정상 완료 시 로그
      await SaveActionLog([modalRowData2], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'SUCCESS',
      });
      return true;
    } catch (e) {
      // 오류 시 로그
      await SaveActionLog([modalRowData2], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'ERROR',
        errorMsg: e.message,
      });

      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
      return false;
    } finally {
      dispatch(closeLoading());
    }
  };

  /** 통합 회의 팝업(modal2): 회의정보 저장 후, 안건 저장 */
  const SaveMeetingPopupCombined = async () => {
    if (IsMeetingMinutesLocked(modalRowData2)) {
      dispatch(
        showSnackbar({
          message: '서명 요청 후에는 회의록을 수정할 수 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    const attendeeCountsUnbalanced =
      attendeeData0.length !== attendeeData1.length;

    const meetingSaved = await SaveLogic1({ suppressSuccessSnackbar: true });
    if (!meetingSaved) {
      return;
    }
    await saveMeetingAgenda();

    if (attendeeCountsUnbalanced) {
      dispatch(
        showSnackbar({
          message:
            '저장되었습니다. 사용자위원과 근로자위원은 동수로 구성하시기 바랍니다.',
          type: 'warning',
        })
      );
    }
  };

  //#endregion
  //#region 회의사진 저장
  //회의사진 저장(file 서버에 업로드)
  const SaveLogic3 = async (_value1, _value2) => {
    try {
      let formList = new FormData();
      let filePath = `Business/${searchInfo.custCd}/SAC_BASIC`;

      // 원본 파일명이 있으면 File 객체의 name을 원본 파일명으로 변경
      let fileToUpload = _value1;
      if (_value2 && _value1 instanceof File) {
        // 원본 파일명으로 새로운 File 객체 생성
        fileToUpload = new File([_value1], _value2, {
          type: _value1.type,
          lastModified: _value1.lastModified,
        });
      }

      formList.append('UserId', userInfo.userid);
      formList.append('FilePath', filePath); // 저장경로(파일명 제외)
      formList.append('FormFile', fileToUpload); // 파일 (원본 파일명 사용)

      const result = await Commons.Axios(
        'file',
        Global.file.useUrl + Global.urls.Execute.videoUpload,
        null,
        formList
      );
      const data = result.data;

      if (data?.filePath) {
        // _value2(원본 파일명)가 있으면 사용, 없으면 서버에서 반환된 파일명 사용
        const serverFilePath = data.filePath.replace(/\\/g, '/');
        const fileName =
          _value2 ||
          serverFilePath.split('/').pop() ||
          serverFilePath.split('\\').pop();

        // 항상 Business/${searchInfo.custCd}/SAC_BASIC/fileName 형식으로 정규화
        const normalizedPath = `Business/${searchInfo.custCd}/SAC_BASIC/${fileName}`;

        return normalizedPath;
      } else {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '파일 업로드 중 오류 발생',
          type: 'error',
        })
      );
      return null;
    }
  };

  //사진 가져오기
  const SearchPhoto = (_filePath) => {
    console.log('_filePath:', _filePath);
    imgRef2.current = toPreviewSrc(_filePath);
  };
  //#endregion
  //#region 저장
  //전체 저장버튼 클릭 시 함수

  //#region 회의록 참석자 저장
  const SaveLogic2 = async (chaebun, attendees = null) => {
    // chaebun 유효성 검사
    if (!chaebun || chaebun.trim() === '') {
      throw new Error('참석자 저장을 위한 채번이 없습니다.');
    }

    // attendees 매개변수가 제공되지 않으면 현재 state 사용
    const attendeesToSave =
      attendees !== null
        ? attendees
        : [
            ...attendeeData0.map((r) => ({ ...r, gubun: '0' })),
            ...attendeeData1.map((r) => ({ ...r, gubun: '1' })),
          ];

    try {
      // 먼저 해당 채번의 모든 참석자명단 데이터 삭제 (기존 데이터 삭제 후 재 인서트)
      try {
        const deleteParams = mapRowsBySchema(
          [{ chaebun: chaebun }],
          SAC_BASIC_Schema.mapper.delete2
        );
        // delete2는 단일 객체를 받으므로 첫 번째 요소만 전송
        const deleteResult = await apiRequest(
          'post',
          Global.urls.SafetyCommittee.deleteSacBasicD2,
          deleteParams[0] || {}
        );

        if (!deleteResult?.isSuccess) {
          throw new Error(
            deleteResult?.message || '참석자 삭제 중 오류가 발생했습니다.'
          );
        }
      } catch (deleteAttendeeError) {
        throw deleteAttendeeError;
      }

      if (attendeesToSave && attendeesToSave.length > 0) {
        for (const attendee of attendeesToSave) {
          if (!attendee.id || attendee.id.trim() === '') {
            continue;
          }

          const saveRow = {
            chaebun: chaebun || '',
            gubun: attendee.gubun || '0', // 기본값을 '0'으로 설정
            id: attendee.id || '',
            depNm: attendee.depNm || '',
            rank: attendee.rank || '',
            name: attendee.name || '',
            tel: attendee.tel || '',
            attendYn: attendee.attendYn || 'N',
            checkYn: attendee.checkYn || 'N',
            checkPath: attendee.checkPath || '',
          };

          // useSave2의 runAsync 사용
          const result = await Save2Async([saveRow]);

          if (!result?.isSuccess) {
            throw new Error(
              result?.message ||
                `참석자 저장 중 오류가 발생했습니다. (${attendee.name || attendee.id})`
            );
          }
        }
      }

      setModalToggle2(false);

      // 그리드 새로고침
      ResetLogic1();
      if (!validateSelection()) return;
      await Search1();
    } catch (e) {
      throw e; // 상위 함수에서 에러 처리하도록 전달
    }
  };
  //#region 삭제

  //참석자 명단 삭제버튼 클릭 시 함수(웹)
  const DeleteLogic2 = async () => {
    dispatch(showLoading());
    try {
      if (!selectedRowData1 || selectedRowData1.length === 0) {
        dispatch(
          showSnackbar({
            message: '항목을 선택하세요.',
            type: 'warning',
          })
        );
        return;
      }

      const deleteRows = selectedRowData1.map((item) => ({
        chaebun: item.chaebun || item.CHAEBUN || '',
      }));

      if (deleteRows.length > 0) {
        const result = await delete2.runAsync(deleteRows);

        if (result?.isSuccess !== false) {
          dispatch(
            showSnackbar({
              message: '삭제되었습니다.',
              type: 'warning',
            })
          );
        } else {
          dispatch(
            showSnackbar({
              message: result?.message || '삭제 중 오류가 발생했습니다.',
              type: 'error',
            })
          );
        }
      }
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
          type: 'error',
        })
      );
      return;
    } finally {
      dispatch(closeLoading());
    }
  };

  //#region 나머지 함수

  const PrintLogic3 = async (_value1) => {
    if (!validateSelection()) return;
    setLoading(true);
    try {
      let printData;

      setMeetingAgendaData([]);
      // 회의사진 영역 리셋
      imgRef2.current = null;

      let headerData = []; // 헤더 데이터
      let tableData1 = []; // 참석자명단(도급)
      let tableData2 = []; // 회의안건

      if (selectedRowData1.length === 0) {
        dispatch(
          showSnackbar({
            message: '항목을 선택하세요.',
            type: 'warning',
          })
        );
        return;
      }

      // 선택된 회의록 데이터 가져오기
      const selectedMeeting = selectedRowData1[0];

      console.log('selectedMeeting', selectedMeeting);

      // 시간 데이터를 안전하게 처리하는 함수
      const formatTime = (timeValue) => {
        if (!timeValue) return '';

        try {
          // 문자열이고 이미 HH:mm 형식인 경우
          if (
            typeof timeValue === 'string' &&
            /^\d{2}:\d{2}$/.test(timeValue)
          ) {
            return timeValue;
          }

          // dayjs로 파싱 시도
          const parsed = dayjs(timeValue);
          if (parsed.isValid()) {
            return parsed.format('HH:mm');
          }

          return '';
        } catch (e) {
          return '';
        }
      };

      // 회의사진 조회
      if (selectedMeeting.proceedingsImage) {
        SearchPhoto(selectedMeeting.proceedingsImage);
      }

      // 1. headerData 설정 - 회의록 기본정보 (회의사진 포함)
      headerData.push({
        proceedingsTitle: selectedMeeting.proceedingsTitle || '',
        proceedingsDateTime: selectedMeeting.proceedingsDate || '',
        proceedingsLocation: selectedMeeting.proceedingsLocation || '',
        state: selectedMeeting.state || '',
        custNm:
          searchInfo.custList.find((item) => item.value === searchInfo.custCd)
            ?.name || '',
        year: _value1,
        quarter: '',
        proceedingsImage: selectedMeeting.proceedingsImage || '', // 회의사진 경로
        proceedingsImageNm: selectedMeeting.proceedingsImageNm || '', // 회의사진 파일명
        meetingPhoto: imgRef2.current
          ? imgRef2.current.replace(
              /^data:image\/[a-z]+;base64,/, // base64 접두사 제거
              ''
            )
          : '', // 회의사진 base64 데이터
      });

      // 2. 참석자명단 데이터 조회 및 설정
      const search2Params = mapParamsBySchema(SAC_BASIC_Schema.mapper.search2, {
        search: {
          chaebun: selectedMeeting.CHAEBUN || selectedMeeting.chaebun || '',
        },
      });

      const search2Result = await apiRequest(
        'post',
        Global.urls.SafetyCommittee.getSacBasicR2,
        search2Params
      );

      if (search2Result?.isSuccess && search2Result?.data) {
        const data = Array.isArray(search2Result.data)
          ? search2Result.data
          : [search2Result.data];

        if (data.length > 0) {
          // GUBUN별로 분리 (사용자위원: '0', 근로자위원: '1')
          const list0 = data.filter((item) => item.gubun === '0'); // 사용자위원
          const list1 = data.filter((item) => item.gubun === '1'); // 근로자위원

          // 두 리스트 중 길이 큰 값과 최소 7 기준
          const maxLength = Math.max(list0.length, list1.length, 7);

          // 최종 리스트 생성
          for (let i = 0; i < maxLength; i++) {
            tableData1.push({
              // 사용자위원 (GUBUN: '0')
              depNm1: list0[i]?.depNm || '',
              name1: list0[i]?.name || '',
              signature1: SignFileConvert(list0[i]?.filePath) || '',
              // 근로자위원 (GUBUN: '1')
              depNm2: list1[i]?.depNm || '',
              name2: list1[i]?.name || '',
              signature2: SignFileConvert(list1[i]?.filePath) || '',
            });
          }
        }
      }

      // 3. 회의안건 데이터 조회 (데이터베이스에서 최신 데이터 직접 조회)
      const search3Params = mapParamsBySchema(SAC_BASIC_Schema.mapper.search3, {
        search: {
          chaebun: selectedMeeting.CHAEBUN || selectedMeeting.chaebun || '',
          searchText: '',
        },
      });

      const search3Result = await apiRequest(
        'post',
        Global.urls.SafetyCommittee.getSacBasicR3,
        search3Params
      );

      if (search3Result?.isSuccess && search3Result?.data) {
        const agendaData = Array.isArray(search3Result.data)
          ? search3Result.data
          : [search3Result.data];

        if (agendaData.length > 0) {
          // 회의안건 데이터 설정 (협의·세부사항)
          const agendaList = agendaData
            .filter((item) => item.agendaName || item.resultDiscussion) // 안건명이나 세부사항이 있는 항목만
            .map((item, index) => ({
              no: index + 1,
              agendaName: item.agendaName || '',
              resultDiscussion: item.resultDiscussion || '',
            }));

          // 9개보다 크면 9개까지만 저장
          if (agendaList.length > 9) {
            agendaList.splice(9);
          }

          tableData2.push(...agendaList);
        } else {
          tableData2.push({ no: '', agendaName: '', resultDiscussion: '' });
        }
      }

      printData = {
        FileName: 'SAC_BASIC',
        HeaderData: JSON.stringify(headerData),
        TableData1: JSON.stringify(tableData1),
        TableData2: JSON.stringify(tableData2),
      };

      console.log('printData', printData);

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // 파일 가져오는 함수
  function SignFileConvert(_filePath) {
    if (!_filePath) return null;

    const signUrl = `${Global.file.useUrl}files/${_filePath}`;
    let testSign = `data:image/png;base64,${signUrl}`;
    let sign1 = testSign.replace(
      /^data:image\/[a-z]+;base64,/, // 단위작업사진(접두사 없어야 됨)
      ''
    );

    return sign1 || '';
  }

  function ResetImage() {
    setInputs((prev) => ({
      ...prev,
      mapFile: '',
      filePath: '',
      fileName: '',
      saveName: '',
      newYn: 'Y',
      isImageDeleted: true, // 이미지 삭제 플래그 추가
    }));
    inputsRef.current = {
      ...inputsRef.current,
      mapFile: '',
      filePath: '',
      fileName: '',
      saveName: '',
      newYn: 'Y',
      isImageDeleted: true, // 이미지 삭제 플래그 추가
    };

    // 이미지 상태 초기화
    setImageFile((preState) => ({
      ...preState,
      mapFileName: '',
      mapFiles: '',
    }));

    if (imgRef2.current) {
      imgRef2.current = null;
    }
  }

  //대표자 정보 조회 (결재요청시 대표자 정보 조회)
  const getCEOInfo = async (chaebun) => {
    try {
      const params = mapParamsBySchema(SAC_BASIC_Schema.mapper.search5);

      const result = await apiRequest(
        'post',
        Global.urls.SafetyCommittee.getSacBasicR5,
        params
      );

      if (result?.isSuccess && result?.data) {
        const data = Array.isArray(result.data) ? result.data : [result.data];
        if (data.length > 0) {
          // chaebun에 해당하는 대표자 정보 찾기
          const ceoInfo = data.find(
            (item) =>
              (item.CHAEBUN || item.chaebun || '') === chaebun &&
              (item.GUBUN || item.gubun) === '대표자'
          );
          return ceoInfo || data[0]; // 대표자 정보 1개 반환 (ID, FCM_TOKEN 등)
        }
      }
      return null;
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '대표자 정보를 불러오는 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return null;
    }
  };

  //#region 참석자 알림요청
  // 참석자 알림요청 (알림보내기 전에 참석자 조회 후 ID 와 FCM_TOKEN 값으로 알림보냄)
  const AlarmResponseData = async (chaebun) => {
    try {
      const params = mapParamsBySchema(SAC_BASIC_Schema.mapper.search2, {
        search: {
          chaebun: chaebun || '',
        },
      });

      const result = await apiRequest(
        'post',
        Global.urls.SafetyCommittee.getSacBasicR2,
        params
      );

      if (result?.isSuccess && result?.data) {
        const data = Array.isArray(result.data) ? result.data : [result.data];
        printRef.current = data; //참석자 명단 데이터
        if (!data || data.length === 0) {
          return {
            attendeeList: [],
          };
        }

        const attendeeList = [];

        data.forEach((item, index) => {
          const fcmToken =
            item.FCM_TOKEN || item.fcmToken || item.FcmToken || '';
          const id = item.ID || item.id || '';
          const name = item.NAME || item.name || '';
          const tel = item.TEL || item.tel || '';

          attendeeList.push({
            FCM_TOKEN: fcmToken,
            ID: id,
            NAME: name,
            TEL: tel,
            IS_EXTERNAL: String(id).trim().startsWith('EXT_'),
          });
        });

        return {
          attendeeList,
        };
      }

      return {
        attendeeList: [],
      };
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '참석자 정보를 불러오는 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return {
        attendeeList: [],
      };
    }
  };

  const HasValidFcmToken = (token) =>
    token &&
    token.trim() !== '' &&
    token !== '0' &&
    token !== 'null' &&
    token !== 'undefined';

  const ParseNotificationBatchResponse = (result, fallbackError) => {
    let data = result?.data;
    let responseData = null;

    if (Array.isArray(data) && data.length > 0) {
      responseData = data[0];
    } else if (data && typeof data === 'object' && !Array.isArray(data)) {
      responseData = data;
    }

    if (responseData) {
      const isSuccess =
        responseData.isSuccess !== undefined
          ? responseData.isSuccess
          : responseData.IsSuccess;

      if (
        isSuccess === false ||
        responseData.type === 'Error' ||
        responseData.Type === 'Error'
      ) {
        return {
          success: false,
          error: responseData.message || responseData.Message || fallbackError,
        };
      }
      if (isSuccess === true) {
        return { success: true };
      }
      if (responseData.StatusType && responseData.StatusType !== 'ERROR') {
        return { success: true };
      }
    }

    if (
      Array.isArray(data) &&
      data.length > 0 &&
      (data[0].type === 'Error' || data[0].Type === 'Error')
    ) {
      return {
        success: false,
        error: data[0].message || data[0].Message || fallbackError,
      };
    }

    if (data === 'Fail' || responseData === 'Fail') {
      return {
        success: false,
        error: '사용자가 어플에 로그인하지 않았습니다.',
      };
    }

    return { success: false, error: '알 수 없는 응답' };
  };

  // 참석자 알림요청 (_value1 : "0", _value2:"선택된 행 데이터")
  const SignRequest = async (_value1, _value2) => {
    const chaebun = _value2?.chaebun;
    const { attendeeList } = await AlarmResponseData(chaebun);

    if (_value1 === '0') {
      // 참석자 정보 조회
      if (!attendeeList[0]?.ID || attendeeList[0]?.ID?.trim() === '') {
        dispatch(
          showSnackbar({
            message: '참석자 명단 추가 후 진행하세요.',
            type: 'warning',
          })
        );
        return;
      }

      const internalAttendees = attendeeList.filter((a) => !a.IS_EXTERNAL);
      const externalAttendees = attendeeList.filter((a) => a.IS_EXTERNAL);

      const validFcmAttendees = internalAttendees.filter((attendee) =>
        HasValidFcmToken(attendee.FCM_TOKEN)
      );
      const validExternalAttendees = externalAttendees.filter(
        (attendee) => attendee.TEL && String(attendee.TEL).trim() !== ''
      );

      const invalidInternalCount =
        internalAttendees.length - validFcmAttendees.length;
      const invalidExternalCount =
        externalAttendees.length - validExternalAttendees.length;

      const alimtalkUrl =
        Global.base.useUrl + Global.urls.Alimtalk.signRequest;

      const fcmResultsPromise = Promise.allSettled(
        validFcmAttendees.map(async (item) => {
          try {
            const payload = [
              {
                ResponseId: Commons.EncryptAES(item.ID),
                RequestId: Commons.EncryptAES(userInfo.userid),
                Title: Commons.EncryptAES('산업안전보건위원회 회의록'),
                Body: Commons.EncryptAES('회의록 참석자 사인요청입니다.'),
                Route: Commons.EncryptAES(`/M_Meeting/detail/I${chaebun}`),
                ResponseData: Commons.EncryptAES(chaebun),
                Gubun: Commons.EncryptAES('AL_001_001'),
                FcmToken: item.FCM_TOKEN || '',
              },
            ];
            const fcmUrl = Global.base.useUrl + Global.urls.FCM.fcm;
            const result = await Commons.Axios('post', fcmUrl, payload);
            const parsed = ParseNotificationBatchResponse(
              result,
              '알림 전송 실패'
            );
            return { ...parsed, name: item.NAME, channel: 'fcm' };
          } catch (error) {
            return {
              success: false,
              error: error.message,
              name: item.NAME,
              channel: 'fcm',
            };
          }
        })
      );

      const alimtalkResultsPromise = Promise.allSettled(
        validExternalAttendees.map(async (item) => {
          try {
            const telDigits = String(item.TEL || '').replace(/\D/g, '');
            const payload = [
              {
                RecipientNo: Commons.EncryptAES(telDigits),
                Name: Commons.EncryptAES(item.NAME || ''),
                Type: Commons.EncryptAES('산업안전보건위원회'),
                Id: Commons.EncryptAES(`I${chaebun}` || ''),
                Tel: Commons.EncryptAES(telDigits),
              },
            ];
            const result = await Commons.Axios('post', alimtalkUrl, payload);
            const parsed = ParseNotificationBatchResponse(
              result,
              '알림톡 전송 실패'
            );
            return { ...parsed, name: item.NAME, channel: 'alimtalk' };
          } catch (error) {
            return {
              success: false,
              error: error.message,
              name: item.NAME,
              channel: 'alimtalk',
            };
          }
        })
      );

      const [fcmResults, alimtalkResults] = await Promise.all([
        fcmResultsPromise,
        alimtalkResultsPromise,
      ]);

      const allResults = [...fcmResults, ...alimtalkResults];
      const allAttendees = [...validFcmAttendees, ...validExternalAttendees];

      const successResults = [];
      const failResults = [];
      const errorResults = [];

      allResults.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          if (result.value.success) {
            successResults.push(result.value);
          } else {
            failResults.push(result.value);
          }
        } else {
          errorResults.push({
            name: allAttendees[index]?.NAME || '알 수 없음',
            error: result.reason?.message || '알 수 없는 오류',
          });
        }
      });

      const successCount = successResults.length;
      const failCount = failResults.length;
      const errorCount = errorResults.length;
      // 통합된 결과 메시지 생성
      let message = '';
      let messageType = 'info';

      if (successCount > 0) {
        const successNames = successResults.map((r) => r.name).join(', ');
        message += `${successCount}명에게 서명 요청 전송 완료: ${successNames}`;
        message +=
          '\n서명 요청 후에는 회의록을 수정할 수 없습니다. (조회만 가능)';
        messageType = 'success';
      }

      if (failCount > 0) {
        const failNames = failResults.map((r) => r.name).join(', ');
        if (message) message += '\n';
        message += `${failCount}명 전송 실패: ${failNames}`;
        if (messageType === 'success') messageType = 'warning';
      }

      if (errorCount > 0) {
        const errorNames = errorResults.map((r) => r.name).join(', ');
        if (message) message += '\n';
        message += `${errorCount}명 전송 중 오류 발생: ${errorNames}`;
        messageType = 'error';
      }

      if (invalidInternalCount > 0) {
        if (message) message += '\n';
        message += `${invalidInternalCount}명은 앱 알림을 받을 수 없습니다. (앱 미설치 또는 로그인 안됨)`;
        if (messageType === 'success') messageType = 'info';
      }

      if (invalidExternalCount > 0) {
        if (message) message += '\n';
        message += `${invalidExternalCount}명은 알림톡을 받을 수 없습니다. (전화번호 미입력)`;
        if (messageType === 'success') messageType = 'info';
      }

      // 통합된 메시지 표시
      if (message) {
        dispatch(
          showSnackbar({
            message: message,
            type: messageType,
          })
        );
      }

      // 서명요청 성공 시 회의록 수정 잠금 플래그 저장
      if (successCount > 0 && chaebun) {
        try {
          await Save4Async([
            {
              chaebun,
              state: '',
              signRequestYn: 'Y',
            },
          ]);
          await Search1();
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      // 대표자 결재요청 로직
      const chaebun = selectedRowData1[0].CHAEBUN;

      try {
        // 대표자 정보 조회
        const ceoInfo = await getCEOInfo(chaebun);

        // FCM 토큰 유효성 검사
        if (
          !ceoInfo ||
          !ceoInfo.FCM_TOKEN ||
          ceoInfo.FCM_TOKEN.trim() === '' ||
          ceoInfo.FCM_TOKEN === '0' ||
          ceoInfo.FCM_TOKEN === 'null' ||
          ceoInfo.FCM_TOKEN === 'undefined'
        ) {
          dispatch(
            showSnackbar({
              message:
                '대표자 정보를 찾을 수 없거나 알림을 받을 수 없습니다. (앱 미설치 또는 로그인 안됨)',
              type: 'warning',
            })
          );
          return;
        }

        // FCM 전송
        const result = await Commons.Axios(
          'post',
          Global.base.useUrl + Global.urls.FCM.fcm,
          [
            {
              ResponseId: Commons.EncryptAES(ceoInfo.CO_ID),
              RequestId: Commons.EncryptAES(userInfo.userid),
              Title: Commons.EncryptAES('산업안전보건위원회 회의록'),
              Body: Commons.EncryptAES('대표자 사인요청입니다.'),
              Route: Commons.EncryptAES(`/M_Meeting/detail/I${chaebun}`),
              ResponseData: Commons.EncryptAES(chaebun),
              Gubun: Commons.EncryptAES('AL_001_002'),
              // FcmToken은 서버에서 GetFcmToken(ResponseId)로 직접 조회하므로 전송하지 않음
            },
          ]
        );

        // 서버 응답 처리: BuildBatchResponse 형식 또는 배열 형식 모두 처리
        const data = result.data;
        let responseData = null;

        // 배열인 경우 첫 번째 요소 사용
        if (Array.isArray(data) && data.length > 0) {
          responseData = data[0];
        } else if (data && typeof data === 'object') {
          // 객체인 경우 그대로 사용
          responseData = data;
        }

        if (responseData) {
          // BuildBatchResponse 형식 체크 (isSuccess, StatusType, Message)
          if (
            responseData.isSuccess === false ||
            responseData.type === 'Error'
          ) {
            dispatch(
              showSnackbar({
                message:
                  responseData.message ||
                  responseData.Message ||
                  '결재요청 전송 중 오류가 발생했습니다.',
                type: 'error',
              })
            );
            return;
          } else if (responseData.isSuccess === true) {
            dispatch(
              showSnackbar({
                message: '1건의 결재요청이 완료되었습니다.',
                type: 'success',
              })
            );
            return;
          }
        }

        // 배열이면서 Error 타입인 경우
        if (
          Array.isArray(data) &&
          data.length > 0 &&
          data[0].type === 'Error'
        ) {
          dispatch(
            showSnackbar({
              message:
                data[0].message || '결재요청 전송 중 오류가 발생했습니다.',
              type: 'error',
            })
          );
          return;
        }

        // Fail 문자열 체크
        if (data === 'Fail' || responseData === 'Fail') {
          dispatch(
            showSnackbar({
              message: '대표자가 어플에 로그인하지 않았습니다.',
              type: 'warning',
            })
          );
          return;
        }

        // 알 수 없는 응답
        dispatch(
          showSnackbar({
            message: '결재요청 전송 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
      } catch (error) {
        dispatch(
          showSnackbar({
            message: '결재요청 전송 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
      }
    }
  };
  //#endregion

  const ResetLogicAll = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
    setInputs({
      chairman: '', //위원장
      proceedingsDate: dayjs().format('YYYY-MM-DD'), //회의일시
      proceedingsLocation: '', //회의장소
      ceo: '', //대표
      workCeo: '', //근로자대표
    });
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };
  return (
    <div className="wrap">
      <SAC_BASIC
        userInfo={userInfo}
        lanList={lanInfo}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        rowData1={rowData1}
        inputs={inputs}
        setInputs={setInputs}
        inputsRef={inputsRef}
        imgRef2={imgRef2}
        gridRef1={gridRef1}
        gridRef2User={gridRef2User}
        gridRef2Labor={gridRef2Labor}
        gridRef3={gridRef3}
        gridRef5={gridRef5}
        gridRef8={gridRef8}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        gubunList={gubunList}
        setGubunList={setGubunList}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        modalToggle2={modalToggle2}
        setModalToggle2={setModalToggle2}
        modalRowData2={modalRowData2}
        setModalRowData2={setModalRowData2}
        attendeeData0={attendeeData0}
        setAttendeeData0={setAttendeeData0}
        attendeeData1={attendeeData1}
        setAttendeeData1={setAttendeeData1}
        attendeeAddTargetGubunRef={attendeeAddTargetGubunRef}
        OpenAttendeeAddModal={OpenAttendeeAddModal}
        modalToggle3={modalToggle3}
        setModalToggle3={setModalToggle3}
        modalRowData3={modalRowData3}
        setModalRowData3={setModalRowData3}
        selectedModalRowData3={selectedModalRowData3}
        setSelectedModalRowData3={setSelectedModalRowData3}
        changedModalRowData3={changedModalRowData3}
        setChangedModalRowData3={setChangedModalRowData3}
        deletedModalRowData3={deletedModalRowData3}
        setDeletedModalRowData3={setDeletedModalRowData3}
        meetingAgendaData={meetingAgendaData}
        setMeetingAgendaData={setMeetingAgendaData}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        attendeeList={attendeeList}
        setAttendeeList={setAttendeeList}
        handleAttendeeSearch={handleAttendeeSearch}
        handleSearchWorkers={handleSearchWorkers}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        searchResults={searchResults}
        setSearchResults={setSearchResults}
        selectedWorkers={selectedWorkers}
        setSelectedWorkers={setSelectedWorkers}
        handleRowSelection={handleRowSelection}
        // 함수
        ResetLogicAll={ResetLogicAll}
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        ResetLogic1={ResetLogic1}
        Search1={Search1}
        SearchLogic1={SearchLogic1}
        DeleteLogic1={DeleteLogic1}
        getCEOInfo={getCEOInfo}
        AlarmResponseData={AlarmResponseData}
        SignRequest={SignRequest}
        SaveLogic1={SaveLogic1}
        SaveMeetingPopupCombined={SaveMeetingPopupCombined}
        SaveLogic2={SaveLogic2}
        DeleteLogic2={DeleteLogic2}
        PrintLogic3={PrintLogic3}
        NewYnErrorMsg={NewYnErrorMsg}
        PopupClickEvent5={PopupClickEvent5}
        addMeetingAgenda={addMeetingAgenda}
        deleteMeetingAgenda={deleteMeetingAgenda}
        saveMeetingAgenda={saveMeetingAgenda}
        handleMeetingStart={handleMeetingStart}
        ResetImage={ResetImage}
        deleteHandler1={deleteHandler1}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        deletedRowData1={deletedRowData1}
        setDeletedRowData1={setDeletedRowData1}
        PopupClickEvent2Update={PopupClickEvent2Update}
        // 로그관련 함수
        SCREEN_MENU_ID={SCREEN_MENU_ID}
        SaveActionLog={SaveActionLog}
      />
    </div>
  );
}

export default SAC_BASICF;
